import { ShareBaseLibrary } from 'phoenix/domain';
import { Library } from 'sharebase/domain';

/**
 * Provides methods for creating @see Library objects.
 */
export class LibraryFactory {
    /**
     * Create an instance of @see Library from the library DTO.
     */
    public create(srvData:ShareBaseLibrary) {
        const lib:Library = angular.merge(srvData, {
            IsLibrary: true
        });
        
        return lib;
    }
}



// WEBPACK FOOTER //
// ./src/sharebase/factories/library-factory.ts